'use client'
"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    HorizonDialog: ()=>HorizonDialog,
    Dialog: ()=>HorizonDialog
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const dialog_namespaceObject = require("@base-ui-components/react/dialog");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const index_cjs_namespaceObject = require("../CdnIcon/index.cjs");
const external_Heading_index_cjs_namespaceObject = require("../Heading/index.cjs");
const external_IconButton_index_cjs_namespaceObject = require("../IconButton/index.cjs");
const external_ScrollArea_index_cjs_namespaceObject = require("../ScrollArea/index.cjs");
const external_Text_index_cjs_namespaceObject = require("../Text/index.cjs");
const external_Dialog_variants_cjs_namespaceObject = require("./Dialog.variants.cjs");
const cn_cjs_namespaceObject = require("../../utils/cn.cjs");
const HorizonDialog = ({ children, description, footer, headingCustomNode, headingIconName, headingRightNode, headingText, open = false, showCloseButton = true, title, triggerNode, onClose, ...props })=>{
    const triggerRef = external_react_default().useRef(null);
    const [isOpen, setIsOpen] = (0, external_react_namespaceObject.useState)(open);
    (0, external_react_namespaceObject.useEffect)(()=>{
        setIsOpen(open);
    }, [
        open
    ]);
    const { popupSlot, popupSlotAnimation, headerSlot, headingSlotLeft, headingRightNodeSlot, closeButtonSlot, headingTextSlot, headingIconSlot, backdropSlot, backdropSlotAnimation, bodySlot, scrollAreaSlot, contentSlot, footerSlot } = (0, external_Dialog_variants_cjs_namespaceObject.dialogVariants)({
        customHeader: !!headingCustomNode,
        customFooter: !!footer,
        customBody: !!children,
        ...props
    });
    const backdropClasses = (0, cn_cjs_namespaceObject.cn)(backdropSlot(), backdropSlotAnimation());
    const popupClasses = (0, cn_cjs_namespaceObject.cn)(popupSlot(), popupSlotAnimation());
    function handleClose() {
        setIsOpen(false);
        onClose?.();
        props.onOpenChange?.(false, void 0);
    }
    function handleOpenChange(open) {
        setIsOpen(open);
        onClose?.();
    }
    const renderDialogHeader = ()=>{
        if (headingCustomNode) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(dialog_namespaceObject.Dialog.Title, {
            render: (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("span", {
                    ...props,
                    children: headingCustomNode
                })
        });
        if (headingText) return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
            className: headerSlot(),
            children: [
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                    className: headingSlotLeft(),
                    children: [
                        headingIconName && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(index_cjs_namespaceObject.CdnIcon, {
                            iconName: headingIconName,
                            size: "24",
                            className: headingIconSlot()
                        }),
                        /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(dialog_namespaceObject.Dialog.Title, {
                            render: (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Heading_index_cjs_namespaceObject.Heading, {
                                    as: "h4",
                                    className: headingTextSlot(),
                                    ...props,
                                    children: headingText
                                })
                        })
                    ]
                }),
                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                    className: headingRightNodeSlot(),
                    children: headingRightNode
                })
            ]
        });
        return null;
    };
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(dialog_namespaceObject.Dialog.Root, {
        open: isOpen,
        onOpenChange: handleOpenChange,
        ...props,
        children: [
            triggerNode && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(dialog_namespaceObject.Dialog.Trigger, {
                ref: triggerRef,
                render: (props)=>/*#__PURE__*/ external_react_default().isValidElement(triggerNode) ? /*#__PURE__*/ external_react_default().cloneElement(triggerNode, props) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                        ...props,
                        children: triggerNode
                    })
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(dialog_namespaceObject.Dialog.Portal, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(dialog_namespaceObject.Dialog.Backdrop, {
                        className: backdropClasses
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(dialog_namespaceObject.Dialog.Popup, {
                        className: popupClasses,
                        finalFocus: triggerRef,
                        "aria-label": title,
                        children: [
                            showCloseButton && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(dialog_namespaceObject.Dialog.Close, {
                                render: (props)=>/*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                        className: closeButtonSlot(),
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_IconButton_index_cjs_namespaceObject.IconButton, {
                                            ...props,
                                            iconName: "close",
                                            type: "primary",
                                            shadow: true,
                                            size: "md",
                                            "aria-label": "Close dialog",
                                            emphasis: "bold",
                                            onClick: handleClose
                                        })
                                    })
                            }),
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)("div", {
                                className: contentSlot(),
                                children: [
                                    renderDialogHeader(),
                                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_ScrollArea_index_cjs_namespaceObject.ScrollArea, {
                                        className: scrollAreaSlot(),
                                        dialogBody: true,
                                        children: [
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(dialog_namespaceObject.Dialog.Description, {
                                                className: bodySlot(),
                                                children: description && /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_Text_index_cjs_namespaceObject.Span, {
                                                    textStyle: "body2",
                                                    className: "inline-block w-full px-6",
                                                    children: description
                                                })
                                            }),
                                            children,
                                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)("div", {
                                                className: footerSlot(),
                                                children: footer
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
exports.Dialog = __webpack_exports__.Dialog;
exports.HorizonDialog = __webpack_exports__.HorizonDialog;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Dialog",
    "HorizonDialog"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
